import { render, staticRenderFns } from "./ModalCodigoVerificacao.vue?vue&type=template&id=44d1ccc9&"
import script from "./ModalCodigoVerificacao.vue?vue&type=script&lang=js&"
export * from "./ModalCodigoVerificacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports